import { render, staticRenderFns } from "./BaseFormField.vue?vue&type=template&id=3220d408&"
import script from "./BaseFormField.vue?vue&type=script&lang=js&"
export * from "./BaseFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports